import {BaseCrudService} from "./baseCrudService";
import {CollectionCreateRequest, CollectionDto} from "../dto/collection-dto";

class CollectionService extends BaseCrudService<CollectionDto> {
  constructor() {
    super("/api/v1/collections", true);
  }
}

export const collectionService = new CollectionService();